module.exports = __webpack_public_path__ + "img/MSTART-trasera-menu.9b4dd69a.jpg";